<template>
  <div>       
    <div class='dataContainer' >
        <ul class="list-group">
            <li class="list-group-item list-group-item-warning" v-show='gotData' >
                <div class="row">
                    <div class="col-xs-12 col-md-9" >  
                        <span class='IndexWidth'    >#</span>
                        <span class='NameWidth mobiletext'     >Marca:&nbsp;&nbsp;<input v-model='filteredName' class='NameWidthHeader' style='width:200px;'>&nbsp;&nbsp;</span></span>
                        <span class='PriorityWidth mobiletext' >Prioridad</span>
                        <span class='ActiveWidth mobiletext'   >Activo</span>                        
                    </div>
                    <div class="hidden-sm  col-md-3" >  
                        <span class='btnWidth' >Detalles</span>
                        <span class='btnWidth' >Borrar</span>
                        <span class='btnWidth' >Guardar</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item" v-show='gotData' >  
                <div class="row">
                    <div class="col-xs-8 col-md-9" >  
                        <span  class='IndexWidth' ></span>
                        <span> <input class='NameWidth form-control'     type='text'     v-model='newItem.brand_name'></span>
                        <span> <input class='PriorityWidth form-control' type='text'     v-model='newItem.brand_priority' v-on:keyup='allowIntOnly' @change='allowIntOnly'></span>                
                        <span  class='ActiveWidth'><input   type="checkbox" class='ActiveInput' v-model="newItem.brand_active"></span>                                            
                    </div>
                    <div class="col-xs-4 col-md-3" >  
                        <span  class='btnWidth' ></span>
                        <span  class='btnWidth' ></span>
                        <span  class='btnWidth' ><button class="btn btn-success glyphicon glyphicon-plus-sign glyphiconSize" @click='addRow(newItem)' ></button></span>
                    </div>
                </div>
            </li>        
            <li class="list-group-item" v-for='(itemDetail, index) in filteredNames'  >  
                <div class="row">
                    <div class="col-xs-8 col-md-9" >  
                        <span  class='IndexWidth' >{{ index+1 }}</span>
                        <span> <input class='NameWidth form-control'     type='text'     v-model='itemDetail.brand_name'></span>
                        <span> <input class='PriorityWidth form-control' type='text'     v-model='itemDetail.brand_priority' v-on:keyup='allowIntOnly' @change='allowIntOnly'></span>                
                        <span  class='ActiveWidth'><input type="checkbox" class='ActiveInput' v-model="itemDetail.brand_active"></span>                        
                    </div>                    
                    <div class="col-xs-4 col-md-3" >  
                        <span  class='btnWidth' ><button v-bind:class="itemDetail.showDetails ? classUpArrow : classDownArrow" @click='detailsRow(itemDetail)' ></button></span>      
                        <span  class='btnWidth' ><button class="btn btn-danger glyphicon glyphicon glyphicon-remove glyphiconSize" @click='deleteRow(itemDetail)' ></button></span>
                        <span  class='btnWidth' ><button class="btn btn-success glyphicon glyphicon-ok glyphiconSize"    @click='updateRow(itemDetail)' ></button></span>
                    </div>
                </div>

                <div v-if='itemDetail.showDetails' >
                    <hr>
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-warning" v-show='gotData' >          
                            <div class="row">
                                <div class="col-xs-12 col-md-12" >  
                                    <div><span class='mobiletext' >&nbsp;&nbsp;&nbsp;&nbsp;Modelos de {{ itemDetail.brand_name }} </span></div>                
                                </div>
                            </div>
                         </li>        
                         <li class="list-group-item"  v-show='gotData'>  
                            <div class="row rowTopMargin" >
                                <div class="col-xs-12 col-md-4"  >  
                                    <div class="input-group form-group ">
                                        <span class="input-group-addon input-group-addon-general">Modelo:</span>
                                        <input type="text" class="form-control"  v-model='newModelItem.model_name' >
                                    </div>
                                </div>
                                <div class="col-xs-4 col-md-3" >  
                                    <div class="input-group form-group ">
                                        <span class="input-group-addon input-group-addon-general">Prioridad:</span>
                                        <input type="text" class="form-control"  v-model='newModelItem.model_priority' v-on:keyup='allowIntOnly' @change='allowIntOnly'>
                                    </div>
                                </div>
                                <div class="col-xs-4 col-md-2" >  
                                    <span class='mobiletext'>&nbsp;&nbsp;&nbsp;&nbsp;Activo</span>
                                    <span><input type="checkbox" class='ActiveModelInput' v-model="newModelItem.model_active"></span>
                                </div>
                                <div class="col-xs-4 col-md-3" >  
                                    <span  class='btnWidth' ><button class="btn btn-success glyphicon glyphicon-plus-sign glyphiconSize" @click='addModelRow(newModelItem,  itemDetail.brand_id)' ></button></span>
                                </div>                                                   
                            </div>                                            
                         </li>                                           
                         <li class="list-group-item"  v-for='(modelDetail, index) in itemDetail.models' v-show='gotData'>  
                            <div class="row rowTopMargin" >
                                <div class="col-xs-12 col-md-4" >  
                                    <div class="input-group form-group ">
                                        <span class="input-group-addon input-group-addon-general">Modelo:</span>
                                        <input type="text" class="form-control"  v-model='modelDetail.model_name' >
                                    </div>
                                </div>
                                <div class="col-xs-4 col-md-3" >  
                                    <div class="input-group form-group ">
                                        <span class="input-group-addon input-group-addon-general">Prioridad:</span>
                                        <input type="text" class="form-control"  v-model='modelDetail.model_priority' v-on:keyup='allowIntOnly' @change='allowIntOnly'>
                                    </div>
                                </div>
                                <div class="col-xs-4 col-md-2" >  
                                    <span class='mobiletext'>&nbsp;&nbsp;&nbsp;&nbsp;Activo</span>
                                    <span><input type="checkbox" class='ActiveModelInput' v-model="modelDetail.model_active"></span>
                                </div>                                
                                <div class="col-xs-4 col-md-3" >  
                                    <span  class='btnWidth' ><button class="btn btn-danger glyphicon glyphicon glyphicon-remove glyphiconSize" @click='deleteModelRow(modelDetail)' ></button></span>
                                    <span  class='btnWidth' ><button class="btn btn-success glyphicon glyphicon-ok glyphiconSize"    @click='updateModelRow(modelDetail, itemDetail.brand_id)' ></button></span>                                    
                                </div>                                                   
                            </div>                                            
                         </li>                         
                    </ul>                    
                    <hr>
                </div>                      
            </li>        
        </ul>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../../main';
import { PaginationMixin } from '../mixin/PaginationMixin';
import { CommonMixin } from '../mixin/CommonMixin';

export default {  
  mixins : [PaginationMixin,CommonMixin],  
  data: function () {     
    return {
        newItem: {
            brand_name:'',
            brand_priority: 99,
            brand_active: true,
            brand_deleted: 0
        },
        newModelItem: {
            model_carbrand_id:0,
            model_name:'',
            model_priority: 99,
            model_active: true,
            model_deleted: 0
        },
        itemDetails: [],
        filteredName: '',
        gotData: false,
        classDownArrow: 'btn btn-info glyphicon glyphicon-chevron-down glyphiconSize',
        classUpArrow:   'btn btn-info glyphicon glyphicon-chevron-up glyphiconSize',     
        maxItemToShow: 6,     
    }
  },
  watch: { // whenever question changes, this function will run        
    $route () {                
        this.getItemsDetails();                
    }
  }, 
  mounted: function () {        
        this.getItemsDetails();
        this.getPaginationLinks('/admin/carbrandadmin/','api/getbrandcount', this.maxItemToShow);
  },
  methods: {
    updateParams : function() {
        if(this.$route.params.offset)
            this.offset = this.$route.params.offset;    
        else
            this.offset = 0;     
    },   
    getItemsDetails: function() {             
        this.updateParams();     

        //var callUrl = 'api/carbrands/maxresult/' + this.maxItemToShow + '/offset/' + this.offset;
        var callUrl = 'api/carbrands/maxresult/99999/offset/0';
        
        this.$http.get(callUrl).then(response => {                                    
            this.itemDetails = response.body.map(obj =>{                                             
                obj.showDetails = false;
                return obj;
            });

            this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },   
    updateRow: function({brand_id,brand_name,brand_priority,brand_active})
    {        
        brand_active = brand_active ? 1 : 0;        
        this.$http.put('api/carbrands/' + brand_id, {name:brand_name,priority:brand_priority,active:brand_active,deleted:0} ).then(response => {                                    
            eventBus.$emit('resultMessage',response);   
            this.getItemsDetails();                                
        }, response => {            
            eventBus.$emit('errorMsg',response);       
        });
    },
    deleteRow: function({brand_id})
    {                        
        this.$http.delete('api/carbrands/' + brand_id).then(response => {                                    
          eventBus.$emit('resultMessage',response);                         
          this.getItemsDetails();
        }, response => {
            eventBus.$emit('errorMsg',response);
        });
    },
    detailsRow: function(itemDetail){        
        itemDetail.showDetails = !itemDetail.showDetails;        
    },
    addRow: function({brand_name,brand_priority,brand_active}){

        brand_active = brand_active ? 1 : 0;        
        this.$http.post('api/carbrands/', {name:brand_name,priority:brand_priority,active:brand_active,deleted:0} ).then(response => {                        
          eventBus.$emit('resultMessage',response);                             
          this.getItemsDetails();          
        }, response => {            
            eventBus.$emit('errorMsg',response);       
        });
    },   
    updateModelRow: function({model_id,model_name,model_priority,model_active}, brand_id)
    {                
        model_active = model_active ? 1 : 0;        
        this.$http.put('api/carmodels/' + model_id, {name:model_name, priority:model_priority, active:model_active, deleted:0, carbrand_id:brand_id} ).then(response => {                                    
            eventBus.$emit('resultMessage',response);   
            this.getItemsDetails();                                
        }, response => {            
            eventBus.$emit('errorMsg',response);       
        });
    },
    deleteModelRow: function({model_id})
    {                        
        this.$http.delete('api/carmodels/' + model_id).then(response => {                                    
          eventBus.$emit('resultMessage',response);                         
          this.getItemsDetails();          
        }, response => {
            eventBus.$emit('errorMsg',response);
        });
    },
    addModelRow: function({model_name,model_priority,model_active,model_deleted}, brand_id){

        model_active = model_active ? 1 : 0;        
        this.$http.post('api/carmodels/', {carbrand_id:brand_id, name:model_name, priority:model_priority, active:model_active, deleted:model_deleted} ).then(response => {                        
          eventBus.$emit('resultMessage',response);                             
          this.getItemsDetails();     
          this.clearNewField();     
        }, response => {            
            eventBus.$emit('errorMsg',response);       
        });
    },   
    clearNewField: function  (){
         this.newModelItem.model_carbrand_id = 0;
         this.newModelItem.model_name        = '';
         this.newModelItem.model_priority    = 99;
         this.newModelItem.model_active      = true;
         this.newModelItem.model_deleted     = 0;        
    }
  },
  filters: {
     
  },
  computed: {
    filteredNames: function() {        
        return this.itemDetails.filter((element) => {                        
            return element.brand_name.toLowerCase().match(this.filteredName.toLowerCase());
        });
    }      
  }
}
</script>

<style scoped>

   .dataContainer{
       width:720px;
       margin-left: 50px;       
   }

   .IndexWidth {
        display:inline-block;
        width:30px;
        padding-left: 10px;
   }
   .NameWidth {
        display:inline-block;
        width:300px;
   }

   .PriorityWidth {
        display:inline-block;
        width:50px;
        margin-left: 20px;
        text-align: right;
   }



   .btnWidth{
       display:inline-block;     
       width:40px;
       margin-left: 10px;           
   }

   .glyphiconSize{
       font-size: 1.4em;
   }

    .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-9 {
        padding-left: 5px;
        padding-right: 5px;
    }

    .rowTopMargin {
        margin-top:15px;
    }


    @media screen and (max-width: 981px) {      

        .rowTopMargin {
            margin-top:35px;
            margin-left: 10px;
            margin-right: 10px;
        }

       
        .dataContainer{
           width:91%;           
        }

        .IndexWidth {
            font-size: 3em;        
            margin-right: 30px;
            padding-left: 10px;
        }

        .NameWidthHeader {
            display:inline-block;
            width:50%;
            font-size: 1em;
        }   

        .mobiletext {
            font-size: 3em;
        }   

        .NameWidth {
            display:inline-block;
            width:55%;
        }

        .PriorityWidth {
            display:inline-block;
            width:15%;
            margin-left: 15px;
            text-align: right;
        }
    
        input {                    
            width:100%;
            height:75px;
            font-size: 2.4em;            
        }

        button {                    
            position:relative;
            width:80px;
            height:80px;
            font-size: 2.5em;                        
        }

        .input-group-addon {                    
            font-weight: 200;
            font-size: 2.8em;                    
        }
        
       .btnWidth{
            width:auto;
            margin-left: 10px;  
            margin-bottom: 10px;
            display:inline-block;      
        }

        .glyphiconSize{
            font-size: 2em;
        }    
       
        .ActiveInput {
            width:10%;
            height: 50px !important;
            display:inline-block;
            margin-left: 15px;
        }

        .ActiveModelInput {
            width:30%;
            height: 50px !important;
            display:inline-block;
        }
        
                
   }

   @media screen and (min-width: 981px) {          
        .col-md-12 {
            padding-left: 0px;
            padding-right: 0px;
        }

        .ActiveWidth {
            display:inline-block;
            width:50px;
            margin-left: 20px;
            text-align: center;
        }
   }

</style>



// WEBPACK FOOTER //
// CarBrandAdmin.vue?5f0e4cbf